module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource-w960.15c697fb.jpg";